// extracted by mini-css-extract-plugin
export var calendar = "article-module--calendar--D0mp-";
export var glasses = "article-module--glasses--sXlSA";
export var tag = "article-module--tag--YWe2d";